import { useEffect, useState, useRef } from 'react'
import BeatLoader from 'react-spinners/BeatLoader'
import QRCode from 'qrcode.react'
import isEmpty from 'lodash/isEmpty'

import { useSelector } from 'react-redux'

import { selectUserInfo } from 'redux/selector/user'

import { fetchDeviceQrcodeWithCache } from 'api/qrcode'

import { Wrapper, BgImg, QRCodeWrapper, TextBox, BtnCopySharingUrl, Link, SiteUrl } from './Styled'
import { useHtml2Image } from 'hooks/useHtml2Image'
import { SAVE_ID_KEY } from 'constant/common'
import { getCachedShowId } from 'redux/saga/user'

export default function IDCard() {
  const downloadLinkRef = useRef<HTMLAnchorElement>(null)
  const cardRef = useRef<HTMLDivElement>(null)
  const userInfo = useSelector(selectUserInfo)
  const [cachedShowId] = useState(getCachedShowId())
  const [url, setUrl] = useState<string | null | undefined>(null)
  const { downloadHtmlAsImage } = useHtml2Image()

  async function download() {
    const card = cardRef.current
    const imageName = userInfo?.show_id ?? cachedShowId ?? 'usercard'
    await downloadHtmlAsImage(card, imageName)
    localStorage.setItem(SAVE_ID_KEY, '1')
  }

  useEffect(() => {
    if (isEmpty(url)) return
  }, [url])

  useEffect(() => {
    fetchDeviceQrcodeWithCache().then((response) => {
      setUrl(response?.code)
    })
  }, [])

  return (
    <Wrapper>
      <BgImg ref={cardRef} onClick={download} data-testid="idcard_dialog_bg" aria-label="idcard_dialog_bg">
        <SiteUrl>官网地址：https://cunse.live</SiteUrl>
        <QRCodeWrapper>
          {!!url ? (
            <QRCode id={'qrcode'} style={{ width: '100%', height: '100%' }} value={url} level={'H'} />
          ) : (
            <BeatLoader size={10} />
          )}
        </QRCodeWrapper>

        <TextBox>
          <BtnCopySharingUrl>截图保存图片</BtnCopySharingUrl>
        </TextBox>
      </BgImg>
      <Link ref={downloadLinkRef}></Link>
    </Wrapper>
  )
}
